<style scoped lang="scss" type="text/scss">
    .info-panel {
        margin-bottom: .5rem;
    }
</style>

<template>
    <el-dialog :title="'正在' + (isUpdate ? '更新' : '添加') + '专项赛'"
               :visible.sync="visibleSync"
               :close-on-click-modal="false"
               @closed="reset"
               width="70%">
        <el-form ref="form" :model="specialCompetitionInfo" :rules="rules" label-width="100px">
            <info-panel class="info-panel">在主赛事中建立的单项赛，会被所有分赛事继承。为方便数据导出，请在主赛事中创建公用单项赛</info-panel>
            <info-panel class="info-panel" style="margin-bottom: 1rem;">基于单项赛性质，继承自主赛事的单项赛表格会包含所有参与了其下属分赛事的参赛队，而非晋级的参赛队</info-panel>

            <el-form-item label="单项赛名称" prop="name">
                <el-input v-model="specialCompetitionInfo.name"></el-input>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="confirm()" :loading="requesting">确认</el-button>
                <el-button @click="cancel()">取消</el-button>
                <el-button v-if="deletable" style="float: right;" type="danger" @click="remove()"
                           :loading="deleteRequesting">删除
                </el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import InfoPanel from '../../../../../../components/info-panel/index';

    export default {
        name: '',
        components: {
            InfoPanel
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            deletable: {
                type: Boolean,
                default: false
            },
            isUpdate: {
                type: Boolean,
                default: false
            },
            id: {
                type: Number,
                default: null
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
                if (!visible) return;
                const id = this.id;
                if (id === null || id === undefined) {
                    this.specialCompetitionInfo = {};
                } else {
                    this.$store.dispatch('competition/loadSpecialCompetitionInfo', {
                        id
                    }).then(response => {
                        this.specialCompetitionInfo = response.data;
                    });
                }
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            }
        },
        data () {
            return {
                requesting: false,
                deleteRequesting: false,
                visibleSync: null,
                specialCompetitionInfo: {},
                rules: {
                    name: [
                        {required: true, message: '单项赛名称不能为空', trigger: 'blur'},
                        {min: 1, max: 30, message: '长度不能超过 50 个字', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            }
        },
        methods: {
            confirm () {
                if (this.isUpdate) {
                    this.update();
                } else {
                    this.create();
                }
            },
            create () {
                this.handleTemplate('competition/createSpecialCompetition', '创建成功');
            },
            update () {
                this.handleTemplate('competition/updateSpecialCompetition', '更新成功');
            },
            handleTemplate (actionName, tip) {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const specialCompetitionInfo = this.specialCompetitionInfo;
                    if (specialCompetitionInfo.competition_id === undefined || specialCompetitionInfo.competition_id === null) {
                        specialCompetitionInfo.competition_id = this.currentCompetitionId;
                    }
                    this.$normalRequest(actionName, specialCompetitionInfo, tip, true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.reset();
            },
            remove () {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('competition/deleteSpecialCompetition', {
                        id: this.id
                    }, '删除成功', true, this, 'deleteRequesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.visibleSync = false;
                this.specialCompetitionInfo = {};
            }
        }
    };
</script>
